import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { ILocalization, withLocalization } from 'bernie-l10n';

import { DayName, renderDatePicker, UitkDateFieldProps } from 'uitk-react-date-picker';
import { RateCalendarModel } from 'src/common/models/common/rate-calendar-model';

export interface DatepickerProps {
  controls?: any;
  datePickerAnalytics?: any;
  dateType?: string;
  endDate?: string;
  l10n?: ILocalization;
  midnightBookingOffsetHours?: any;
  numDaysBookableInAdvance?: number;
  startDate?: string;
  textValues?: any;
  fetchDatePickerRates?: () => Promise<object>;
}

export interface DatePickerState {
  rates?: RateCalendarModel;
}

@withLocalization
export class Datepicker extends React.Component<UitkDateFieldProps & DatepickerProps, DatePickerState> {
  constructor(props) {
    super(props);

    this.state = {
      rates: {}
    };
  }

  public componentDidMount() {
    const { fetchDatePickerRates } = this.props;

    if (fetchDatePickerRates && typeof fetchDatePickerRates === 'function') {
      fetchDatePickerRates().then(rates => {
        if (rates && typeof rates === 'object') {
          this.setState({ rates } as DatePickerState);
        }
      });
    }
  }

  public render() {
    const {
      controls,
      datePickerAnalytics,
      dateType,
      endDate,
      l10n,
      midnightBookingOffsetHours,
      numDaysBookableInAdvance,
      startDate,
      textValues
    } = this.props;

    return renderDatePicker(
      dateType,
      startDate,
      endDate,
      numDaysBookableInAdvance,
      midnightBookingOffsetHours,
      datePickerAnalytics,
      controls,
      textValues,
      DayName[l10n.getWeekData().firstDay.toUpperCase()],
      this.state.rates
    );
  }
}
